import { useCallback, useEffect } from 'react';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import { selectedCurrencyVar } from '../../../gqlCommon/graphql/cache';
import { useReactiveVar } from '@apollo/client';
import useCustomerStorage from '../../../common/hooks/useCustomerStorage';

interface IUsePersistedCurrencyPreferenceReturn {
  isSecondaryCurrencyDisplay: boolean;
  setIsSecondaryCurrencyDisplay: () => void;
}

export const usePersistedCurrencyPreference: () => IUsePersistedCurrencyPreferenceReturn = () => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const selectedCurrency = useReactiveVar(selectedCurrencyVar);
  const { primary, secondary } = priceDisplay;
  const { customerStorage } = useCustomerStorage();
  const isSecondaryCurrencyDisplay =
    primary.currency !== secondary?.currency && secondary?.currency === selectedCurrency;
  const customerData = customerStorage.getCustomerData();
  const customerSelectedCurrency = customerData?.selectedCurrency;

  useEffect(() => {
    selectedCurrencyVar(customerSelectedCurrency || primary?.currency);
  }, [customerSelectedCurrency, primary]);

  const setIsSecondaryCurrencyDisplay = useCallback(() => {
    customerData.selectedCurrency = selectedCurrencyVar(
      isSecondaryCurrencyDisplay ? primary.currency : secondary.currency,
    );
    customerStorage.setCustomerData(customerData);
  }, [customerData, primary, secondary, isSecondaryCurrencyDisplay]);

  return { isSecondaryCurrencyDisplay, setIsSecondaryCurrencyDisplay };
};
